import type { AccountExport } from "@pushback-and-chaos/contracts";
import { ACCOUNT_DATA } from "../design/copy.js";

/**
 * Whether settings shows the account door (2026-10-12): anyone the server can name has an
 * account to copy, a guest before any profile exists as much as a signed-in learner. Unlike
 * the coach's door beside it, it never waits for a profile. Kept here so a test holds the rule.
 */
export function accountExportDoorOpen(guestId: string | null, signedIn: boolean): boolean {
  return guestId !== null || signedIn;
}

/**
 * The client read is supplied by the app: the settings door's is guarded, so its errors use the
 * app's usual notice; the erasure dialog's is not, and the dialog says so itself. Answers whether
 * a copy was saved.
 */
export async function downloadAccountExport(read: () => Promise<AccountExport | null>): Promise<boolean> {
  const data = await read();
  if (data === null) return false;
  const url = URL.createObjectURL(new Blob([JSON.stringify(data, null, 2)], { type: "application/json" }));
  const link = document.createElement("a");
  link.href = url;
  link.download = ACCOUNT_DATA.exportFile;
  document.body.append(link);
  try {
    link.click();
  } finally {
    link.remove();
    URL.revokeObjectURL(url);
  }
  return true;
}
